import React from 'react';
import './ScrollToBottomButton.css';

const ScrollToBottomButton = ({ targetId }) => {
  const scrollToSection = () => {
    const section = document.getElementById(targetId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="scroll-cue" aria-hidden="true" onClick={scrollToSection}></div>
  );
};

export default ScrollToBottomButton;